import { render, staticRenderFns } from "./index-notification.vue?vue&type=template&id=40e4ca2c&scoped=true&"
import script from "./index-notification.vue?vue&type=script&lang=js&"
export * from "./index-notification.vue?vue&type=script&lang=js&"
import style0 from "./index-notification.vue?vue&type=style&index=0&id=40e4ca2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e4ca2c",
  null
  
)

export default component.exports